import { render } from "./InternalPercentage.vue?vue&type=template&id=a264cf1a"
import script from "./InternalPercentage.vue?vue&type=script&lang=js"
export * from "./InternalPercentage.vue?vue&type=script&lang=js"
script.render = render

export default script